import { TranslateService } from '@ngx-translate/core';
import { FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { CreateUserModel } from '../../../system-management/users/models/create-user-model';
import { ICreateAccountUserRequest, Role } from '../dtos';

export class CreateAccountUserModel implements ICreateAccountUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  systemRoles?: string[];
  specializedRoles?: string[];
  phoneNumber: string;
  private constructor(request: ICreateAccountUserRequest) {
    this.email = request.email;
    this.firstName = request.firstName;
    this.lastName = request.lastName;
    this.password = request.password;
    this.systemRoles = request.systemRoles;
    this.specializedRoles = request.specializedRoles;
    this.phoneNumber = request.phoneNumber;
  }

  static create(request: ICreateAccountUserRequest): CreateAccountUserModel {
    return new CreateAccountUserModel(request);
  }

  static createDefault(): CreateAccountUserModel {
    return new CreateAccountUserModel({
      ...CreateUserModel.createDefault(),
      phoneNumber: ''
    });
  }

  getFormConfig(roles: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    let userModel = CreateUserModel.create(this);
    return [...userModel.getFormConfig(roles, isVisible, translate)];
  }
}
